import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";

interface StoriesHeroProps {
  total: number;
  authorCount: number;
}

export default function StoriesHero({ total, authorCount }: StoriesHeroProps) {
  return (
    <section className="relative min-h-[62vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Atmospheric%20early%20morning%20scene%20of%20an%20Indian%20farmer%20standing%20in%20a%20green%20field%20looking%20over%20the%20land%2C%20misty%20fresh%20light%2C%20deep%20shadows%2C%20painterly%20stylized%20earthy%20tones%2C%20storytelling%20mood%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=stories-hero&orientation=landscape"
          width={1920}
          height={1080}
          alt="An Indian farmer looking over the land in the fresh morning light"
          title="Stories From the Soil - Rythugaru farmer stories"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Stories From the Soil</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            Farmer Journals & Diaries
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Every Farmer Has a <span className="italic text-accent-300">Story.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          The most powerful stories aren't always found in cities. They are found in fields, in the
          hands of farmers, and in generations of farming knowledge. Here, we tell them.
        </p>

        <div className="flex flex-wrap gap-x-10 gap-y-5 mt-10">
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              {total}
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Stories Published</p>
          </div>
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              {authorCount}
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Voices Featured</p>
          </div>
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              Monthly
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">New Stories</p>
          </div>
        </div>
      </div>
    </section>
  );
}